import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { BusinessInfoService } from '@api-client';
import { getKeyByValue, TermType } from '@common';
import { LepiIcon, ModalService } from '@lepisode-ui/components';
import { injectParams } from 'ngxtension/inject-params';
import { BehaviorSubject } from 'rxjs';
import { telPipe } from '../../../pipes/tel-transform.pipe';
declare const Kakao: any;
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, LepiIcon, telPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  router = inject(Router);
  id = injectParams('id');
  modalService = inject(ModalService);
  businessInfoService = inject(BusinessInfoService);

  refresh$ = new BehaviorSubject<void>(undefined);
  businessInfo = toSignal(
    this.businessInfoService.businessInfoControllerFind(),
  );

  termTypeList = Object.entries(TermType).map(([key, value]) => ({
    key,
    value,
  }));

  getKeyByValue = getKeyByValue;
  termType = TermType;

  connectKakao() {
    window.open('http://pf.kakao.com/_cWMEn/chat', '_blank');
  }

  scrollToTop() {
    const currentScroll =
      document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (currentScroll > 0) {
      window.requestAnimationFrame(() => {
        window.scrollTo(0, currentScroll - currentScroll / 25);
        this.scrollToTop();
      });
    }
  }
}
